__turbopack_context__.v({
  "className": "cormorant_garamond_e3a1e23f-module__NJONNG__className",
});
